/** Mirrors the server's BillPaymentMethodType, sent as each row's `rowType`. */
export enum BillPaymentRowType {
    OnlinePayment = 0,
    VendorCreditApplied = 1,
    OfflinePayment = 2,
}

const paymentKindSuffixes: Partial<Record<BillPaymentRowType, string>> = {
    [BillPaymentRowType.OnlinePayment]: "(Bill Pay)",
    [BillPaymentRowType.OfflinePayment]: "(Offline)",
};

/**
 * Payment method text with how the payment was made appended: "ACH (Bill Pay)", "Check #1042 (Offline)".
 * A blank or missing method shows the suffix alone, so the kind is always visible.
 * Vendor credit (and an unknown kind) returns the method unchanged; it has no online/offline kind to show.
 */
export const getPaymentMethodLabel = (
    paymentMethod: string | null | undefined,
    rowType: BillPaymentRowType | undefined,
): string | null => {
    const suffix = rowType === undefined ? undefined : paymentKindSuffixes[rowType];
    if (!suffix) {
        return paymentMethod ?? null;
    }

    const method = paymentMethod?.trim();
    return method ? `${method} ${suffix}` : suffix;
};
